"use client";

import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from "react";
import Confetti from "react-confetti";

interface ConfettiContextType {
    triggerConfetti: () => void;
}

const ConfettiContext = createContext<ConfettiContextType | undefined>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useConfetti = () => {
    const context = useContext(ConfettiContext);
    if (!context) {
        throw new Error("useConfetti must be used within a ConfettiProvider");
    }
    return context;
};

interface ConfettiProviderProps {
    children: ReactNode;
}

export const ConfettiProvider = ({ children }: ConfettiProviderProps) => {
    const [showConfetti, setShowConfetti] = useState(false);

    const triggerConfetti = useCallback(() => {
        setShowConfetti(true);
        setTimeout(() => {
            setShowConfetti(false);
        }, 10_000);
    }, []);

    const value = useMemo(() => {
        return { triggerConfetti };
    }, [triggerConfetti]);
    return (
        <ConfettiContext.Provider value={value}>
            {children}
            {showConfetti && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 9999 }}>
                    <Confetti width={window.innerWidth} height={window.innerHeight} recycle={false} numberOfPieces={200} />
                </div>
            )}
        </ConfettiContext.Provider>
    );
};
